/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

const containerStyles = css({
	display: 'flex',
	flexDirection: 'column',
	gap: token('space.100'),
	paddingBlock: token('space.200'),
	paddingInline: token('space.200'),
});

const itemSkeletonStyles = css({
	backgroundColor: token('color.skeleton'),
	height: '16px',
	borderRadius: token('radius.small'),
});

export const CsmAppSidebarSkeleton = (): React.JSX.Element => (
	<div css={containerStyles}>
		<div css={itemSkeletonStyles} />
		<div css={itemSkeletonStyles} />
		<div css={itemSkeletonStyles} />
	</div>
);
